import { render, staticRenderFns } from "./DeveloperListApartmentBuildings.vue?vue&type=template&id=58cba220&"
import script from "./DeveloperListApartmentBuildings.vue?vue&type=script&lang=js&"
export * from "./DeveloperListApartmentBuildings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports